import { render, staticRenderFns } from "./lookSysMajor.vue?vue&type=template&id=7d487b26&scoped=true&"
import script from "./lookSysMajor.vue?vue&type=script&lang=js&"
export * from "./lookSysMajor.vue?vue&type=script&lang=js&"
import style0 from "./lookSysMajor.vue?vue&type=style&index=0&id=7d487b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d487b26",
  null
  
)

export default component.exports